var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.024 10.292h7.263c1.657 0 3-1.343 3-3V3.025c0-1.657-1.343-3-3-3H3.024c-1.657 0-3 1.343-3 3v4.267c0 1.657 1.343 3 3 3z",
    transform: "translate(-152 -829) translate(153 830)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M.858 1.164l4.607 3.22c.699.488 1.63.48 2.32-.022L12.413 1h0",
    transform: "translate(-152 -829) translate(153 830)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.789 3.85L1.101 9.508M8.474 3.85L12.412 9.508",
    transform: "translate(-152 -829) translate(153 830)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailField);
export default __webpack_public_path__ + "static/media/email-field.b828fa96.svg";
export { ForwardRef as ReactComponent };